/* eslint-disable no-nested-ternary */
import { Controller } from 'react-hook-form'
import { Link } from 'react-router-dom'
import {
  ContainerTitle,
  DivTitle,
} from '../../../components/TitlePage/TitlePage'
import { useUsersAdm } from '../useUsersAdm'
import { papelMultiVendedor } from '../../Users/useUsers'
import { CpfsVendedores } from '../../../components/CpfsVendedores/CpfsVendedores'
import {
  BtnAdicionar,
  BtnRemover,
  BtnSave,
  DivAccess,
  DivForm,
  DivVinculos,
  FormLogin,
  InputLogin,
  LabelLogin,
  PrincipalDiv,
  SelectVinculo,
  VinculoRow,
} from './style'
import { DivTop, Span } from '../../PredictionDetails/PredictionDetails.style'
import { ReturnIcon } from '../../../assets/icons/Return'
import ToggleSwitch from '../../../components/Switch/Switch'
import { Ul } from '../../../layouts/LayoutTable/LayoutTable'
import { ItemFilter } from '../../../components/ItemFilter/ItemFilter'

export function NewUserAdm() {
  const {
    control,
    emailValidation,
    register,
    searchValueNome,
    setSearchValueNome,
    searchValueEmail,
    setSearchValueEmail,
    searchValueSenha,
    setSearchValueSenha,
    searchValueConfirmarSenha,
    setSearchValueConfirmarSenha,

    handleClear,
    checked,
    handleCheckboxChange,
    setStatus,
    status,

    campoObrigatorioNome,
    campoObrigatorioEmail,
    campoObrigatorioSenha,
    campoObrigatorioConfirmarSenha,

    senhaNaoConfere,
    emailConfere,

    handleValidaEditarSalvar,

    organizacoesDisponiveis,
    vinculos,
    adicionarVinculo,
    removerVinculo,
    handleChangeVinculoOrganizacao,
    handleChangeVinculoPapel,
    handleChangeVinculoCpf,
    handleChangeVinculoCpfs,
    erroVinculoLinha,
    carregandoVinculos,
  } = useUsersAdm()

  return (
    <>
      <DivTitle id="saudacaoUsuariosPermissoes" color="black" size={22}>
        <ContainerTitle>
          <DivTop>
            <Link onClick={handleClear} to="/adm-user">
              <ReturnIcon />
            </Link>
            <Span> Novo Usuário</Span>
          </DivTop>
        </ContainerTitle>
      </DivTitle>

      <PrincipalDiv>
        <form>
          <h3>Dados do usuário</h3>
          <DivForm>
            <FormLogin>
              <LabelLogin htmlFor="name">Nome completo</LabelLogin>
              <InputLogin
                {...register('name')}
                id="name"
                type="text"
                value={searchValueNome}
                onChange={event => setSearchValueNome(event.target.value)}
                required
              />
              {campoObrigatorioNome ? <span>*Campo obrigatório</span> : ''}
            </FormLogin>

            <FormLogin>
              <LabelLogin htmlFor="email">E-mail</LabelLogin>
              <InputLogin
                {...register('email', emailValidation)}
                id="email"
                type="email"
                value={searchValueEmail}
                onChange={event => setSearchValueEmail(event.target.value)}
                required
              />
              {campoObrigatorioEmail ? <span>*Campo obrigatório</span> : ''}
              {emailConfere ? <span>*Formato de e-mail inválido</span> : ''}
            </FormLogin>
            <Controller
              name="isActive"
              control={control}
              render={({ field: { ref, ...field } }) => (
                <ToggleSwitch
                  adm
                  id="status"
                  label={status ? 'Ativo' : 'Inativo'}
                  checked={status}
                  {...field}
                  onClick={() => (status ? setStatus(false) : setStatus(true))}
                />
              )}
            />
          </DivForm>
          <DivForm>
            <FormLogin>
              <LabelLogin htmlFor="senha">Senha</LabelLogin>
              <InputLogin
                {...register('password')}
                id="senha"
                type="password"
                value={searchValueSenha}
                onChange={event => setSearchValueSenha(event.target.value)}
                required
              />
              {campoObrigatorioSenha ? <span>*Campo obrigatório</span> : ''}
            </FormLogin>
            <FormLogin>
              <LabelLogin htmlFor="confirmarSenha">Confirmar senha</LabelLogin>
              <InputLogin
                {...register('confirmPassword')}
                id="confirmarSenha"
                type="password"
                value={searchValueConfirmarSenha}
                onChange={event =>
                  setSearchValueConfirmarSenha(event.target.value)
                }
                required
              />
              {campoObrigatorioConfirmarSenha ? (
                <span>*Campo obrigatório</span>
              ) : (
                ''
              )}
              {senhaNaoConfere ? (
                <span>
                  *As senhas não coincidem. Por favor, tente novamente.
                </span>
              ) : (
                ''
              )}
            </FormLogin>
          </DivForm>
          <DivAccess>
            <h3>Nível de acesso</h3>
            <div>
              <Ul>
                <ItemFilter
                  top="2px"
                  checked={checked.includes('ADMINISTRADOR')}
                  onChange={() => {
                    // handleFiltroStatus(['Todos'])
                    handleCheckboxChange()
                  }}
                  text="Administrador"
                  id="adm"
                />
                <ItemFilter
                  top="2px"
                  checked={checked.includes('USUARIO')}
                  onChange={() => {
                    handleCheckboxChange()
                  }}
                  text="Usuário"
                  id="usuario"
                />
              </Ul>
            </div>
          </DivAccess>

          {checked.includes('USUARIO') && (
            <>
              <h3>Organizações</h3>
              <DivVinculos>
                {carregandoVinculos ? (
                  <span>Carregando organizações...</span>
                ) : (
                  ''
                )}

                {vinculos.map((vinculo, index) => {
                  const erroLinha = erroVinculoLinha(index)

                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={index}>
                      <VinculoRow>
                        <FormLogin>
                          <LabelLogin htmlFor={`organizacao-${index}`}>
                            Organização
                          </LabelLogin>
                          <SelectVinculo
                            id={`organizacao-${index}`}
                            value={vinculo.organizacaoId}
                            onChange={event =>
                              handleChangeVinculoOrganizacao(
                                index,
                                Number(event.target.value)
                              )
                            }
                          >
                            <option value={0}>Selecione</option>
                            {organizacoesDisponiveis.map(org => (
                              <option key={org.id} value={org.id}>
                                {org.nome}
                              </option>
                            ))}
                          </SelectVinculo>
                        </FormLogin>

                        <FormLogin>
                          <LabelLogin htmlFor={`papel-${index}`}>
                            Papel
                          </LabelLogin>
                          <SelectVinculo
                            id={`papel-${index}`}
                            value={vinculo.papelOrganizacao}
                            onChange={event =>
                              handleChangeVinculoPapel(
                                index,
                                event.target.value as PapelOrganizacaoType
                              )
                            }
                          >
                            <option value="ADMINISTRADOR">Administrador</option>
                            <option value="COORDENADOR">Coordenador</option>
                            <option value="ASSISTENTE">Assistente</option>
                            <option value="VENDEDOR">Vendedor</option>
                          </SelectVinculo>
                        </FormLogin>

                        {vinculo.papelOrganizacao === 'VENDEDOR' && (
                          <FormLogin>
                            <LabelLogin htmlFor={`cpf-${index}`}>
                              CPF
                            </LabelLogin>
                            <InputLogin
                              id={`cpf-${index}`}
                              type="text"
                              value={vinculo.cpfcnpj}
                              onChange={event =>
                                handleChangeVinculoCpf(
                                  index,
                                  event.target.value
                                )
                              }
                            />
                          </FormLogin>
                        )}

                        {/* PD-0004: coordenador e assistente acompanham varios vendedores. */}
                        {papelMultiVendedor(vinculo.papelOrganizacao) && (
                          <CpfsVendedores
                            cpfs={vinculo.cpfcnpjs}
                            onChange={cpfs =>
                              handleChangeVinculoCpfs(index, cpfs)
                            }
                            idPrefix={`vinculo-${index}`}
                          />
                        )}

                        <BtnRemover
                          type="button"
                          onClick={() => removerVinculo(index)}
                        >
                          Remover
                        </BtnRemover>
                      </VinculoRow>

                      {erroLinha ? (
                        <span className="erro">{erroLinha}</span>
                      ) : (
                        ''
                      )}
                    </div>
                  )
                })}

                <BtnAdicionar type="button" onClick={adicionarVinculo}>
                  + Adicionar organização
                </BtnAdicionar>
              </DivVinculos>
            </>
          )}

          <BtnSave onClick={handleValidaEditarSalvar} type="button">
            Salvar
          </BtnSave>
        </form>
      </PrincipalDiv>
    </>
  )
}
